var _circle, _path, _path2, _path3, _path4, _path5;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMlpLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 9,
    stroke: "#02B27F",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.3018 8.19578L8.69043 8.4305L10.0364 6.37305L10.3018 8.19578Z",
    fill: "#02B27F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7832 18.3698L10.9724 18.4878L7.43262 11.1225L7.5911 10.8802L10.6282 10.438L11.7832 18.3698Z",
    fill: "#02B27F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0499 7.64969L12.4384 7.88441L12.168 6.02783L14.0499 7.64969Z",
    fill: "#02B27F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0002 9.94496L14.5928 17.9606L13.9206 18.0587L12.7656 10.1265L15.712 9.69727L16.0002 9.94496Z",
    fill: "#02B27F"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9336 9.18551L15.7438 7.88283L12.0373 8.4225L11.6137 5.51221L10.4154 5.68651L10.8393 8.59712L7.13281 9.13679L7.32261 10.4395L11.0291 9.89979L12.2527 18.3014L13.4507 18.1268L12.2271 9.72518L15.9336 9.18551Z",
    fill: "#F2AE00"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMlpLight);
export default __webpack_public_path__ + "static/media/mlpLight.ab1ba68a09733d055da9af1f0bf1a3f4.svg";
export { ForwardRef as ReactComponent };